import { render, staticRenderFns } from "./loading.modal.vue?vue&type=template&id=78f6315a&"
import script from "./loading.modal.vue?vue&type=script&lang=ts&"
export * from "./loading.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports